import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const ChevronRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.59009 16.34L13.1701 11.75L8.59009 7.16L10.0001 5.75L16.0001 11.75L10.0001 17.75L8.59009 16.34Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
